import React, { useEffect } from "react";

import "./UploadToast.scss";

interface UploadToastProps {
  message: string;
  onClose: () => void;
  duration?: number;
}

export const UploadToast: React.FC<UploadToastProps> = ({
  message,
  onClose,
  duration = 4000,
}) => {
  useEffect(() => {
    const timer = window.setTimeout(onClose, duration);
    return () => clearTimeout(timer);
  }, [onClose, duration]);

  return (
    <div className="upload-toast" role="alert">
      <span className="upload-toast__icon material-symbols-outlined">
        warning
      </span>
      <span className="upload-toast__message">{message}</span>
      <button
        type="button"
        className="upload-toast__close"
        onClick={onClose}
        aria-label="close"
      >
        <span className="material-symbols-outlined">close</span>
      </button>
    </div>
  );
};
